<template lang="html">
    <div class="page" id="proProfile">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2 green_dark">
            <div v-if="player">
                <header>
                    <h2>{{ player.first_name }} {{ player.last_name }}</h2>
                    <ul class="links">
                        <li>
                            <router-link
                                class="cancel"
                                :to="{ name: 'proPlayer', params: { id: $route.params.id } }"
                                ><x-icon class="icon"
                            /></router-link>
                        </li>
                    </ul>
                </header>

                <section class="section">
                    <span class="label">Relevant medical conditions / injuries</span>
                    <span class="value">None</span>
                </section>

                <section class="section">
                    <span class="label">Date of birth</span>
                    <span class="value">{{ $date(player.dob).format("DD MMMM YYYY") }}</span>
                </section>

                <section class="section">
                    <span class="label">Gender</span>
                    <span class="value"> {{ player.gender }}</span>
                </section>

                <section class="section">
                    <span class="label">Email address</span>
                    <span class="value">{{ player.email }}</span>
                </section>

                <section class="section">
                    <span class="label">Contact telephone</span>
                    <span class="value">{{ player.phone }}</span>
                </section>

                <section class="section">
                    <span class="label">Left/ Right handed</span>
                    <span class="value">{{ player.handed }}</span>
                </section>

                <section class="section">
                    <span class="label">Shoe size</span>
                    <span class="value">{{ player.shoe }}</span>
                </section>
            </div>
            <!-- End player -->

            <pre-loader v-else textColor="white" color="white" />
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import preLoader from "@/components/App/Pre-loader";
export default {
    name: "profile",
    components: { FadeImage, preLoader, XIcon },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
};
</script>

<style lang="scss" scoped>
#proProfile {
    .label,
    .value {
        display: block;
    }
    .links {
        li {
            a {
                color: white;
            }
        }
    }
    .section {
        border-bottom: 1px solid #444745;
        padding: 15px 0px;
        .label {
            color: #939a93;
            margin-bottom: 5px;
        }
        .value {
            color: white;
            font-size: 20px;
        }
        &:last-of-type {
            border-bottom: 0px;
        }
    }
}
</style>
